exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mail-ernie{background:url(" + require("public/images/ernie/registration-sprite.png") + ") 200px -170px;width:200px;height:170px;display:inline-block}", ""]);

// exports
